import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationAddRecipientService } from './notification-add-recipients-template.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
export interface TableElement {  
  customerID: number;  
  customerName: string;  
  customerContactName: string;  
  customerContactEmail: string;  
  source: string;
  iconSets: string;  
  disabled?:boolean;
}
@Component({
  selector: 'dl-notification-add-recipients-template',
  templateUrl: './notification-add-recipients-template.component.html',
  styleUrls: ['./notification-add-recipients-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationAddRecipientsTemplateComponent {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns = ['select', 'customerID', 'customerName', 'customerContactName', 'customerContactEmail', 'source','iconSets'];
  dataSource = this._notificationAddRecipientService.list$;
  selection = new SelectionModel<TableElement>(true, []);
  controls: FormArray;
  selectedRow;
  lastUpdate; 
  @Input() public addRowData: Subject<any>;
  @Output() public isFeedbackOptionAdded = new EventEmitter<{ isOptAdded: boolean,isSendNotificationDisable: boolean }>();
  @Output() public isFoRowSelected = new EventEmitter<{ rowSelected: any }>();
  @Output() public isRecipientAdded = new EventEmitter<{ control: any }>();
  @Input() public isDeleteDisabledCheck:Subject<any>;
  @Input() public contactList: any = [];
  public duplicatesList: any = [];

  constructor(private changeDetectorRef: ChangeDetectorRef,private readonly _notificationAddRecipientService: NotificationAddRecipientService,private _QnSbnService:QnSbnService) {}
  ngOnInit() {
    const toGroups = this._notificationAddRecipientService.list$.value.map(entity => {
      return new FormGroup(
        {
          customerID: new FormControl(entity.customerID, Validators.required),
          customerName: new FormControl(entity.customerName, Validators.required),
          customerContactName: new FormControl(entity.customerContactName, Validators.required),
          customerContactEmail: new FormControl(entity.customerContactEmail, Validators.required),
          source: new FormControl(entity.source, Validators.required),         
        },
        { updateOn: 'change' }
      );
    });
   
    this.controls = new FormArray(toGroups);
    this.addRowData.subscribe(data=>{
      if(data === "Manual"){ 
        this.addRecipientManual();
      }else{
        this.addRecipientImportFile(data);
      }
    })
  
    this.isDeleteRows();

    this.dataSource.subscribe(
      d=>{
        this.changeDetectorRef.detectChanges();
      }
    )
  }

  isDeleteRows(){
    this.isDeleteDisabledCheck.subscribe(d=>{
      if(d =="deleteClicked"){
        this.selection.selected.forEach((selectEle,j)=>{
        const index = this._notificationAddRecipientService.list.indexOf(selectEle);
          this.controls.value.map((ctrlEle,i)=>{
            if(JSON.stringify(selectEle) === JSON.stringify(ctrlEle) && index === i){                       
              this.controls.controls.splice(i,1);
              this.controls.value.splice(i,1);      

              this._notificationAddRecipientService.changeUpdate(i,this.trimSpaces(this.controls.value))
            }
          }) 
        });
        this.selection.selected.length=0;
        this.selection.clear();
        this.isUnChecked();

        this._notificationAddRecipientService.changeUpdate(0,this.trimSpaces(this.controls.value))

        this._notificationAddRecipientService.addRecipientsControls.next({name:'delete',control:this.controls})
      }
    })
  }

  isAllSelected() {
   let numSelected = this.selection.selected.length;
    if(numSelected>0){
     this.isFoRowSelected.emit({rowSelected:false})
     this._notificationAddRecipientService.addRecipientsControls.next({name:'checked',control:this.controls})
   }
    // const numDisabled = this._notificationAddRecipientService.list.filter(row => row.disabled).length;
    const numRows = this._notificationAddRecipientService.list.length;
    return numSelected //+ numDisabled === numRows;
  }

  isUnChecked(){
    if(this.selection.selected.length==0){
      this.isFoRowSelected.emit({rowSelected:true})
      this._notificationAddRecipientService.addRecipientsControls.next({name:'unchecked',control:this.controls})
    }
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this._notificationAddRecipientService.list.forEach(row => (!row.disabled ? this.selection.select(row) : ''));
  }

  public addRecipientManual(){
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ .]{2,30}$/;
    const sourceRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ ._\-&0-9,']{2,}$/;
    // const sourceRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ ._\-&0-9,']{2,100}$/;
    this.controls.push(new FormGroup(
      {
        customerID: new FormControl(0, [Validators.required]),
        customerName: new FormControl("", [Validators.required, Validators.pattern(sourceRegex)]),
        customerContactName: new FormControl("", [Validators.required, Validators.pattern(nameRegex)]),
        customerContactEmail: new FormControl("", [Validators.required, Validators.pattern(emailRegex)]),
        source: new FormControl("", [Validators.required, Validators.pattern(sourceRegex)]),
      },
      { updateOn: 'change'}
    ))
    this._notificationAddRecipientService.add();  

    this._notificationAddRecipientService.addRecipientsControls.next({name:'add',control:this.controls})
  }

  public addRecipientImportFile(filedata){
    filedata.map(data => {
      let columnName = Object.keys(data);
      let build_array=new FormGroup({
        customerID: new FormControl(data[columnName[0]], Validators.required),
        customerName: new FormControl(data[columnName[1]], Validators.required),
        customerContactName: new FormControl(data[columnName[2]], Validators.required),
        customerContactEmail: new FormControl(data[columnName[3]], Validators.required),
        source: new FormControl(data[columnName[4]], Validators.required),
      },
        { updateOn: 'change'}
      );
      this.controls.push(build_array); 

      return build_array;
    })

    this._notificationAddRecipientService.changeUpdate(0,this.trimSpaces(this.controls.value))

    this._notificationAddRecipientService.addRecipientsControls.next({name:'importByFile',control:this.controls})

    this.isRecipientAdded.emit({control:this.trimSpaces(this._notificationAddRecipientService.list)});
    
    this.duplicatesList = this.findObjectDuplicates(this.trimSpaces(this.contactList), this.trimSpaces(this._notificationAddRecipientService.list));
  }

  updateField(index, field) {
    const control = this.getControl(index, field);
    if (control.valid) {
      this._notificationAddRecipientService.update(index, field, this.trimSpaces(control.value));

      this.lastUpdate = {
        index,
        field,
        value: this.trimSpaces(control.value)
      };
    }
  }

  getControl(index, fieldName) {
    return this.controls.at(index).get(fieldName) as FormControl;
  }

  addNewNotificationRecipient(ele,i,iconClick):void{    
    if(iconClick === 'no'){
      this.controls.value.pop();
      this.controls.controls.pop();
    }else{
      this.controls.value[i]['iconSets'] = "";
    }   

    this._notificationAddRecipientService.changeUpdate(i,this.trimSpaces(this.controls.value));

    this._notificationAddRecipientService.addRecipientsControls.next({name:'update',control:this.controls})

    this.isRecipientAdded.emit({control:this._notificationAddRecipientService.list})
    let checkLength = this.controls.controls.length > 0;
    this.isFeedbackOptionAdded.emit({ isOptAdded: true,isSendNotificationDisable: checkLength });

    this.duplicatesList = this.findObjectDuplicates(this.trimSpaces(this.contactList), this.trimSpaces(this._notificationAddRecipientService.list));
  }

  public findObjectDuplicates(array1, array2) {
    const set1 = new Set();
    const set2 = new Map();
    const duplicates = [];

    // Helper function to add keys to the set1
    function addToSet(set, item) {
        set.add(`id:${item.customerID}|email:${item.customerContactEmail}`);
    }

    // Add unique keys from array1 to set1
    array1.forEach(item => {
        addToSet(set1, item);
    });

    // Check array2 against set1 and itself
    array2.forEach(item => {
        const keyEmail = `id:${item.customerID}|email:${item.customerContactEmail}`;
        const keyName = `id:${item.customerID}|name:${item.customerName}`;

        // Condition 1: id and email are the same
        if (set1.has(keyEmail) || set2.has(keyEmail)) {
            duplicates.push(item);
        }

        // Condition 2: id is the same but name is different
        const existingItem = set2.get(`id:${item.customerID}`);
        if (existingItem && existingItem.customerName !== item.customerName) {
            duplicates.push(item);
        }

        // Add the item to set2 to track duplicates within array2
        set2.set(`id:${item.customerID}`, item);
        set2.set(keyEmail, item);
    });

    return duplicates;
  }


  public isDuplicated(target){
    return this.compareObjectToExistingArray(target, this.duplicatesList)
  }

  public compareObjectToExistingArray(obj, arr) {
    return arr.some(item => this.isEqual(obj, item));
  }

  public isEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keys1.every(key => obj1[key] === obj2[key]);
  }

  trimSpaces(data){
    data.map(i=>{
      if(i.customerContactName!==undefined || '' || null){
        i.customerContactName=i.customerContactName.trim()
      } 
      if(i.customerContactEmail!==undefined || '' || null){
        i.customerContactEmail=i.customerContactEmail.trim()
      } 
      if(i.customerID!==undefined || '' || null){
        i.customerID=i.customerID.trim()
      }
      if(i.customerName!==undefined || '' || null){
        i.customerName=i.customerName.trim()
      }
      if(i.source!==undefined || '' || null){
        i.source=i.source.trim()
      }
    })
    return data;
  }

}
